export default {
  isValidDate(date) {
    return date && date !== "Invalid date";
  }
};
